module.exports = __webpack_public_path__ + "img/AutoNation.73e51050.png";